import { css } from '@emotion/react';
import { theme } from '@xometry/xometry_loft';

export const s = {
  BillingAccountsCreate: css`
    width: 375px;
    margin-left: 3rem;
    margin-top: ${theme.space[6]};
    input {
      height: 2rem;
    }
  `,
  mainTitle: css`
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes[3]};
  `,
  formTitle: css`
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes[2]};
    margin-bottom: ${theme.space[4]};
    margin-top: ${theme.space[6]};
  `,
  form: css`
    width: 344px;
  `,
  widthFull: css`
    width: 100%;
  `,
  widthHalf: css`
    width: 50%;
  `,
  widthThird: css`
    width: 33%;
  `,
  widthQuarter: css`
    width: 25%;
    vertical-align: top;
  `,
  inline: css`
    display: inline-block;
  `,
  paddingleft: css`
    padding-left: 10px;
  `,
  paddingLeftRight: css`
    padding-left: 10px;
    padding-right: 10px;
  `,
  gapRight: css`
    margin-right: 0.25rem;
  `,
  smallText: css`
    font-size: ${theme.fontSizes[1]};
    font-weight: normal;
  `,
};

export const selectTheme = (rsTheme) => ({
  ...rsTheme,
  spacing: {
    ...rsTheme.spacing,
    baseUnit: 0,
  },
});

export const reactSelectStyle = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#1979c3' : '#849583',
    boxShadow: state.isFocused ? '0 0 4px 0 #1979c3' : 'none',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    width: '100%',
    minHeight: '32px',
    height: '32px',
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 0,
  }),
  menuList: (provided) => ({
    ...provided,
    paddingBottom: '4px',
    paddingTop: '4px',
  }),
  option: (provided) => ({
    ...provided,
    padding: '8px 12px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '100%',
    padding: '2px 8px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '32px',
    minHeight: '32px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '8px',
    marginRight: '0!important',
  }),
};

export default s;
